import { SearchBox } from "@omni/components/components/Search/SearchBar/components/SearchBox/searchBox";
import { cn } from "@omni/utils/styles";

type Props = {
    className?: string;
};

export const SearchBoxComponent = ({ className }: Props) => {
    return (
        <div className={cn("tw:flex tw:items-center", className)}>
            <SearchBox.CloseButton
                className={cn(
                    "tw:h-8 tw:mr-4 tw:flex tw:items-center",
                    "tw:lg:hidden"
                )}
            />
            <SearchBox.Form
                className={cn(
                    "tw:h-12 tw:rounded-3xl tw:bg-grey tw:flex tw:items-center tw:grow"
                )}
            >
                <SearchBox.Form.Input
                    className={cn("tw:pl-4 tw:grow tw:outline-none")}
                />
                <SearchBox.Form.ResetButton
                    color={"secondary"}
                    className={cn(
                        "tw:flex tw:items-center tw:justify-center tw:h-8 tw:w-8 tw:mr-2 tw:p-0 tw:rounded-full"
                    )}
                >
                    <i className={cn("las la-times")} />
                </SearchBox.Form.ResetButton>
                <SearchBox.Form.SubmitButton
                    color={"transparent"}
                    className={cn(
                        "tw:flex tw:justify-center tw:items-center tw:bg-transparent tw:text-black tw:hover:bg-transparent tw:focus:bg-transparent tw:h-8! tw:w-8! tw:mr-2 tw:rounded-full tw:p-0"
                    )}
                >
                    <i
                        className={cn("las la-lg la-search", "tw:rotate-y-180")}
                    />
                </SearchBox.Form.SubmitButton>
            </SearchBox.Form>
        </div>
    );
};
